"use client";

import React, { useState, useEffect } from "react";
import { Button, Checkbox, Input } from "antd";
import { Loader2 } from "lucide-react";

const { TextArea } = Input;

const options = [
  "Got another opportunity",
  "Personal reasons",
  "Relocation issue",
  "Role mismatch",
  "Other",
];

const RejectionContent = ({ reason, setReason, handleReject, isLoading }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [text, setText] = useState("");

  useEffect(() => {
    if (!reason) {
      setSelectedOption(null);
      setText("");
      return;
    }
    if (reason.startsWith("Other:")) {
      setSelectedOption("Other");
      setText(reason.slice(6).trim());
    } else {
      setSelectedOption(reason);
      setText("");
    }
  }, [reason]);

  const handleCheckboxChange = (option) => {
    if (option === selectedOption) {
      setSelectedOption(null);
      setText("");
      setReason("");
    } else {
      setSelectedOption(option);
      if (option !== "Other") {
        setText("");
        setReason(option);
      } else {
        setReason("Other");
      }
    }
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    setText(newText);
    setReason(newText.trim() ? `Other: ${newText.trim()}` : "Other");
  };

  return (
    <div>
      <h2
        style={{ marginTop: "-1.3rem" }}
        className="color-heading mb-4 text-left"
      >
        We're sorry to see you go! Please tell us why you're not proceeding.
      </h2>
      <div className="flex flex-col gap-2 mb-3">
        {options.map((option) => (
          <label key={option} className="flex items-center gap-2">
            <Checkbox
              checked={selectedOption === option}
              onChange={() => handleCheckboxChange(option)}
            />
            <span className="text-base font-bold">{option}</span>
          </label>
        ))}
      </div>

      {selectedOption === "Other" && (
        <TextArea
          className="rounded-lg mt-1"
          rows={4}
          value={text}
          onChange={handleTextChange}
          placeholder="Please specify..."
        />
      )}

      <div className="flex justify-start mt-4">
        <button
          disabled={isLoading}
          className="danger-btn flex"
          onClick={handleReject}
        >
          <div> Submit & Decline Offer</div>

          {isLoading && (
            <div className="ml-2">
              <Loader2 className="animate-spin" />
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default RejectionContent;
